import { Routes } from "../constants/Routes";
import { UserRole } from "../constants/UserRole";
import { TileData } from "../models/TileData";
import { GetUserRoles, UserHasRoleOrHigher } from "../services/AuthService";

/** Data shared between dashboard tiles and dropdown menu items. Lists are not the same! */
export const AllDashboardTiles = {
  UserList: {
    headerRaw: "userListTitle",
    footerRaw: "userListDescription",
    icon: "sap-icon://employee-lookup",
    target: Routes.USER_LIST,
    roles: ["Admin", "Internal", "Manager", "Partner"],
  } as TileData,
  Partners: {
    headerRaw: "partnersTitle",
    footerRaw: "partnersDescription",
    icon: "sap-icon://business-card",
    target: Routes.PARTNER_LIST,
    roles: ["Internal"],
  } as TileData,
  BusinessUnits: {
    headerRaw: "businessUnitsTitle",
    footerRaw: "businessUnitsDescription",
    icon: "sap-icon://business-one",
    target: Routes.BUSINESS_UNIT_LIST,
    roles: ["Admin"],
  } as TileData,
  ContractsList: {
    headerRaw: "contractsListTitle",
    footerRaw: "contractsListDescription",
    icon: "sap-icon://decision",
    target: Routes.CONTRACT_LIST,
    roles: ["Internal"],
  } as TileData,
  MeasurementUnitList: {
    headerRaw: "measurementUnitList",
    footerRaw: "measurementUnitDescription",
    icon: "sap-icon://activity-items",
    target: Routes.MEASUREMENT_UNIT_LIST,
    roles: ["Internal"],
  } as TileData,
  ServiceList: {
    headerRaw: "serviceListTitle",
    footerRaw: "serviceListDescription",
    icon: "sap-icon://technical-object",
    target: Routes.SERVICE_LIST,
    roles: ["Internal"],
  } as TileData,
  EditPriceList: {
    headerRaw: "editPriceList",
    footerRaw: "servicePriceListDescription",
    icon: "sap-icon://sales-order-item",
    target: Routes.SERVICE_PRICE_LIST,
    roles: ["Admin"],
  } as TileData,
  PriceListOverview: {
    headerRaw: "priceListOverview",
    footerRaw: "priceListOverview",
    icon: "sap-icon://sales-order-item",
    target: Routes.PRICE_LIST_OVERVIEW,
    roles: ["Internal", "Partner"],
  } as TileData,
  WorkOrderList: {
    headerRaw: "workOrderListTitle",
    footerRaw: "workOrderListDescription",
    icon: "sap-icon://offsite-work",
    target: Routes.WORK_ORDER_LIST,
    roles: ["Admin", "Internal", "Manager", "Partner"],
  } as TileData,
  SpecificationList: {
    headerRaw: "specificationListTitle",
    footerRaw: "specificationListDescription",
    icon: "sap-icon://collections-insight",
    target: Routes.SPECIFICATION_LIST,
    roles: ["Internal", "Partner"],
  } as TileData,
  InvoiceList: {
    headerRaw: "invoiceListTitle",
    footerRaw: "invoiceListDescription",
    icon: "sap-icon://sales-document",
    target: Routes.WORK_ORDER_LIST,
    roles: ["Internal"],
  } as TileData,
  LogList: {
    headerRaw: "auditLogs",
    icon: "sap-icon://history",
    target: Routes.LOG_LIST,
    roles: ["Admin"],
  } as TileData,
  Analytics: {
    headerRaw: "analytics",
    icon: "sap-icon://business-objects-experience",
    target: Routes.ANALYTICS,
    roles: ["Director"],
  } as TileData,
};

interface ItemWithRoles {
  roles: UserRole[];
}

export function FilterTiles<T extends ItemWithRoles>(allTiles: T[]): T[] {
  const userRoles = GetUserRoles();
  return allTiles.filter((t) => {
    if (!t.roles || t.roles.length === 0) return true;
    for (const role of t.roles) {
      // if a tile only has the "Partner" role, we don't want to show it to internal users
      if (role === "Partner") {
        if (userRoles.includes("Partner")) return true;
      } else if (UserHasRoleOrHigher(role)) return true;
    }
  });
}
